import { render, staticRenderFns } from "./EditInterfaceText.vue?vue&type=template&id=aaf0e6b2&scoped=true"
import script from "./EditInterfaceText.vue?vue&type=script&lang=js"
export * from "./EditInterfaceText.vue?vue&type=script&lang=js"
import style0 from "./EditInterfaceText.vue?vue&type=style&index=0&id=aaf0e6b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf0e6b2",
  null
  
)

export default component.exports